<div class="page-container gap-24">
  <app-title-card id="title-card" [titleCard]="titleCard"></app-title-card>
  <span class="align-self-stretch subtitle">
    Werde Dozent/Dozentin bei InWi – Gestalte Fortbildungen mit Wirkung!
  </span>
  <span class="align-self-stretch font-regular-body-large">
    Du bist Expert*in auf Deinem Fachgebiet und möchtest Dein Wissen mit anderen
    teilen? Bei InWi bieten wir Dir die Möglichkeit, praxisorientierte und
    evidenzbasierte Fortbildungen zu gestalten – für Fachkräfte, die ihr Wissen
    erweitern und direkt anwenden möchten.
  </span>
  <span class="align-self-stretch subtitle"> Was uns wichtig ist: </span>
  <ul class="align-self-stretch">
    <li>
      <span class="font-bold-body-large"> Transparenz: </span>
      <span class="font-regular-body-large">
        Qualität steht bei uns an erster Stelle. Deshalb bitten wir um einen
        Einblick in die Inhalte Deiner Fortbildung sowie die zugrunde liegenden
        Studien. So stellen wir sicher, dass wir unser Versprechen einer hohen
        fachlichen Qualität einlösen können.
      </span>
    </li>
    <li>
      <span class="font-bold-body-large"> Absprache: </span>
      <span class="font-regular-body-large">
        Gemeinsam entwickeln wir Fortbildungen, die nicht nur informieren,
        sondern auch direkt in den Arbeitsalltag integriert werden können.
      </span>
    </li>
    <li>
      <span class="font-bold-body-large"> Aktualität: </span>
      <span class="font-regular-body-large">
        Wir halten regelmäßig Kontakt mit unseren Dozierenden, um
        sicherzustellen, dass alle Angebote stets auf dem neuesten
        wissenschaftlichen Stand sind.
      </span>
    </li>
  </ul>
  <span class="align-self-stretch subtitle"> Was wir dir bieten: </span>
  <ul class="align-self-stretch">
    <li>
      <span class="font-bold-body-large"> Wissenschaftliche Fundierung: </span>
      <span class="font-regular-body-large">
        Wir stehen für evidenzbasierte Fortbildungen und unterstützen Dich bei
        der Recherche und Aufbereitung relevanter Studien sowie bei der
        Gestaltung Deiner Inhalte.
      </span>
    </li>
    <li>
      <span class="font-bold-body-large"> Praxisorientierung: </span>
      <span class="font-regular-body-large">
        Gemeinsam erarbeiten wir Fortbildungen, die nicht nur Wissen vermitteln,
        sondern den Teilnehmenden konkrete Werkzeuge für ihre tägliche Arbeit an
        die Hand geben.
      </span>
    </li>
    <li>
      <span class="font-bold-body-large"> Umfassende Unterstützung: </span>
      <ul>
        <li>
          <span class="font-regular-body-large">
            <em>Vor der Fortbildung</em>: Wir helfen Dir bei der Konzeption,
            Aktualisierung und Aufbereitung deiner Inhalte.
          </span>
        </li>
        <li>
          <span class="font-regular-body-large">
            <em>Während der Fortbildung</em>: Wir kümmern uns um die
            Organisation, die Bereitstellung von Materialien und die digitale
            Plattform.
          </span>
        </li>
      </ul>
    </li>
    <li>
      <span class="font-bold-body-large"> Faire Vergütung: </span>
      <span class="font-regular-body-large">
        Deine Expertise wird bei uns wertgeschätzt. Wir besprechen mit Dir gerne
        individuelle Konditionen und sorgen für eine transparente
        Zusammenarbeit.
      </span>
    </li>
    <li>
      <span class="font-bold-body-large"> Marketing und Organisation: </span>
      <span class="font-regular-body-large">
        Wir übernehmen die Bewerbung Deiner Fortbildung – von Social Media bis
        hin zu weiteren Kanälen – und unterstützen Dich auch beim
        Teilnehmermanagement sowie der Nachbereitung.
      </span>
    </li>
  </ul>
  <span class="flex-c gap-8 align-self-stretch">
    <span class="font-bold-body-large"> Werde Teil unseres Netzwerks! </span>
    <span class="font-regular-body-large">
      Wir bei InWi möchten Wissen zugänglich machen und Fachkräfte in ihrer
      Entwicklung unterstützen. Wenn Du diese Vision teilst, melde Dich bei uns
      und werde Teil eines engagierten Teams. Gemeinsam setzen wir neue Maßstäbe
      in der Fortbildung!
    </span>
  </span>
</div>
<div class="sticky-container-bottom">
  <button class="inwi-text-button-large-primary" routerLink="/about/contact">
    <div class="button-content">
      <div class="button-text">Melde dich jetzt</div>
    </div>
  </button>
</div>
